module.exports = __webpack_public_path__ + "img/scratches_overlay.3c51fef0.jpeg";